import { SchemeApiService, SchemeFileUploadService, AssesmentApiService } from "../../config/apiServices";
import { GET_SCHEMES_URL, GET_USER_DATA, POST_SCHEME_DOC_DATA, POST_SCHEME_DATA, GET_USER_SCHEME_STAT, GET_USER_SCHEME_APPLICATIONS, POST_SCHEME_RESUBMIT_DATA, GET_SCHEME_APPLICATION_REMARK_DATA, GET_ASSESSMENT_RECORDS } from "../../config/commonApiUrl/CommonApiUrlConfig";

export const getAllSchemesList = () => {
  return SchemeApiService.get(GET_SCHEMES_URL);
};

export const getUserDetails = () => {
  return SchemeApiService.get(GET_USER_DATA);
};

export const getUserSchemeStats = () => {
  return SchemeApiService.get(GET_USER_SCHEME_STAT);
};

export const getUserSchemeApplications = (schemeId, limit, page) => {
  return SchemeApiService.get(`${GET_USER_SCHEME_APPLICATIONS}?scheme_id=${schemeId}&limit=${limit}&page=${page}`);
};

export const uploadSchemeDocument = (payload) => {
  return SchemeFileUploadService.post(POST_SCHEME_DOC_DATA, payload);
};

export const applyForScheme = (payload) => {
  return SchemeApiService.post(POST_SCHEME_DATA, payload);
};

export const getSubmittedFormData = (applicantId) => {
  return SchemeApiService.get(`${GET_USER_SCHEME_APPLICATIONS}?applicant_id=${applicantId}`);
};

export const resubmitSchemeApplication = (payload) => {
  return SchemeFileUploadService.post(POST_SCHEME_RESUBMIT_DATA, payload);
};

export const getApplicationRemarksData = (applicantId) => {
  return SchemeApiService.get(`${GET_SCHEME_APPLICATION_REMARK_DATA}/${applicantId}`);
};

export const getUserAssessmentRecords = (
  search = "",
  page = 1,
  limit = 10
) => {
  return AssesmentApiService.get(GET_ASSESSMENT_RECORDS, {
    params: { page, limit, search },
  });
};